export const TERNARY_REGEX = /^\s*\$\{([^}]+)\}(?:\s*(==|!=)\s*(["'])?([^"']+)\3)?\s*\?\s*(["'])?([^"']+?)\5?\s*:\s*(["'])?([^"']+?)\7?\s*$/;

export const VALID_ENUM_VALUE_REGEX = /^[a-zA-Z0-9_\-\.]+$/;
export const SCHEMA_BLOCK_HEADER_REGEX = /^\[.*\]$/;
export const VALID_SCHEMA_KEY_REGEX = /^[a-zA-Z0-9_\-\.]+$/;
